// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__3RJM1","moveBlick":"style_moveBlick__1kShk","base":"style_base__1B5EH","orange":"style_orange__v1pCG","yellow":"style_yellow__1inNw"};